export { default } from './RelatedProducts';
export * from './models.d';
